import '@fortawesome/fontawesome-pro/css/fontawesome.css'
import '@fortawesome/fontawesome-pro/css/light.css'
import '@fortawesome/fontawesome-pro/css/regular.css'
import '@fortawesome/fontawesome-pro/css/solid.css'
import '@data-grid/styles/ag-grid-styles.css'
import '@data-grid/styles/ag-custom-theme-hl.css'
import '@assets/main.css'
import '@mono/packages/ui/styles/component-styles.css'

import { Montserrat } from 'next/font/google'
import { Suspense, useEffect } from 'react'
import dynamic from 'next/dynamic'
import AppMain from '@components/App/AppMain'

const AuthProvider = dynamic(() => import('@components/App/AuthProvider'), {
  ssr: false,
})

const montserrat = Montserrat({
  variable: '--font-family-default',
  style: 'normal',
  subsets: ['cyrillic', 'latin'],
})
const fontClassName = `${montserrat.variable} ${montserrat.className}`

function App({
  pageProps,
  Component,
  ...rest
}) {
  useEffect(() => {
    const fontClasses = fontClassName.split(' ')

    document.body.classList.add(...fontClasses)

    return () => {
      document.body.classList.remove(...fontClasses)
    }
  }, [])

  const appProps = {
    ...rest,
    pageProps,
    Component,
  }
  return (
    <div className={fontClassName}>
      <Suspense>
        <AuthProvider pageProps={pageProps} Component={Component}>
          {Component.AppComponent ? (
            <Component.AppComponent {...appProps} />
          ) : (
            <AppMain {...appProps} />
          )}
        </AuthProvider>
      </Suspense>
    </div>
  )
}

export default App
